import { lazy } from "react";

const routes = [
  {
    path: "/subPages",
    element: lazy(() => import("../../pages/ModulePersonalization/SubPages")),
  },
  {
    path: "/subPages/create",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubPages/create-editSubPages"),
    ),
  },
  {
    path: "/subPages/edit/:id",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubPages/create-editSubPages"),
    ),
  },
];

export default routes;
